import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Button } from 'semantic';
import HelpTip from 'components/HelpTip';
import { Search } from 'components';
import { formatDateTime } from 'utils/date';
import { currentUserCanAccess } from 'utils/roles';
import FetchObject from 'components/FetchObject';
import { API_URL } from 'utils/env';
import { getToken } from 'utils/api/token';
import ConfirmDelete from 'components/ConfirmDelete';
import { request } from 'utils/api';
import CreateSandboxModal from 'components/modals/CreateSandboxModal';

export default function SandboxesTable() {
  const { t } = useTranslation();
  const { items, loading } = useContext(Search.Context);
  if (!items || loading) return null;
  const writeAccess = currentUserCanAccess('sandbox', 'write');
  const token = getToken();
  return (
    <>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={4}>
              {t('sandboxes.columnName', 'Name')}
            </Table.HeaderCell>
            <Table.HeaderCell width={2}>
              {t('sandboxes.columnHumanID', 'Human ID')}
            </Table.HeaderCell>
            <Table.HeaderCell width={2}>
              {t('sandboxes.columnParentProvider', 'Parent Provider')}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('sandboxes.columnCreated', 'Created')}
              <HelpTip
                title={t('sandboxes.columnCreated', 'Created')}
                text={t(
                  'sandboxes.columnCreatedToolTip',
                  'This is the date and time the credential was created.'
                )}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('sandboxes.columnActions', 'Actions')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {items.map((item) => {
            return (
              <Table.Row key={item.id}>
                <Table.Cell>
                  <a
                    target="_blank"
                    href={
                      API_URL +
                      `/1/sandboxes/switch/${item.id}?access_token=${token}`
                    }>
                    {item.name}
                  </a>
                  <p>
                    <small>{item.id}</small>
                  </p>
                </Table.Cell>
                <Table.Cell>{item.slug}</Table.Cell>
                <Table.Cell>
                  {item.parentProviderId ? (
                    <FetchObject
                      endpoint="sandboxes"
                      id={item.parentProviderId}>
                      {(parentProvider) => <span>{parentProvider.name}</span>}
                    </FetchObject>
                  ) : (
                    '-'
                  )}
                </Table.Cell>
                <Table.Cell>{formatDateTime(item.createdAt)}</Table.Cell>
                <Table.Cell textAlign="center">
                  <CreateSandboxModal
                    initialValues={item}
                    update
                    onSubmit={(value) =>
                      request({
                        method: 'PATCH',
                        path: `/1/sandboxes/${item.id}`,
                        body: {
                          name: value.name,
                          description: value.description,
                          sandboxProductModules: value.sandboxProductModules,
                        },
                      })
                    }
                    trigger={
                      <Button
                        basic
                        icon="pen-to-square"
                        title="Edit"
                        disabled={!writeAccess}
                      />
                    }
                  />
                  <ConfirmDelete
                    trigger={
                      <Button
                        basic
                        icon="trash"
                        title="Delete"
                        disabled={!writeAccess}
                      />
                    }
                    objectName="Sandbox"
                    name={item.name}
                    onConfirm={async () => {
                      await request({
                        method: 'DELETE',
                        path: `/1/sandboxes/${item.id}`,
                      });
                      // reload the page
                      window.location.reload();
                    }}
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
}
